module.exports = __webpack_public_path__ + "res/Roboto-Black-webfont.eot?2a5b60f198bcc5a1f773be36a0e34185";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Black-webfont.eot
// module id = 81
// module chunks = 0